import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutdpScanned extends Layout {
    sourceBolimgd: DataSource;
    textboxBimdLoadNo: Textbox;
    textboxToday: Textbox;
    textboxTotal: Textbox;
    textboxWeek: Textbox;
    textboxYesterday: Textbox;
}
